function _filterEmpty(o) {
    return Object.keys(o).length > 0;
}

function mergeMatch({ $and: andA = [], $or: orA = [], ...ra },
    { $and: andB = [], $or: orB = [], ...rb }) {
    const r = {
        $and: andA.concat(andB, ra, rb).filter(_filterEmpty),
        $or: orA.concat(orB).filter(_filterEmpty),
    };
    if (r.$and.length === 0)
        delete r.$and;
    if (r.$or.length === 0)
        delete r.$or;

    return r;
}

function optimizeMongoPipeline(pipeline) {
    if (!Array.isArray(pipeline)) return pipeline;
    const pl = [];
    let prev;

    for (let stage of pipeline) {
        const cur = Object.keys(stage)[0];
        if (cur === '$match' && prev === '$match') {
            pl[pl.length - 1] = { $match: mergeMatch(pl[pl.length - 1].$match, stage.$match) };
        } else {
            switch (cur) {
                case '$facet':
                    const newFacet = {};
                    for (let [key, pipeline] of Object.entries(stage.$facet)) {
                        newFacet[key] = optimizeMongoPipeline(pipeline);
                    }
                    pl.push({ $facet: newFacet })
                    break;
                case '$lookup':
                    const lookup = {
                        ...stage.$lookup,
                        pipeline: optimizeMongoPipeline(stage.$lookup.pipeline),
                    };
                    if (lookup.pipeline === undefined) delete lookup.pipeline;
                    pl.push({
                        $lookup: lookup
                    });
                    break;
                default:
                    pl.push(stage);
                    break;
            }

        }
        prev = cur;
    }

    return pl;
}

module.exports = optimizeMongoPipeline;